import { InlineMessage } from '@strata/react-inline-message';
import { AddressDetailLabelValue } from '@strata/react-label-value-pairs';
import { useFormikContext } from 'formik';

import { SupplierDetails } from 'store/reference/referenceSlice';

interface BillingAddressSectionProps {
    childSupplierDetails?: SupplierDetails;
}

export const BillingAddressSection = ({
    childSupplierDetails = undefined,
}: BillingAddressSectionProps) => {
    const formik = useFormikContext<{ supplierNpi?: string }>();
    return (
        <div className="padding__around--small">
            <div className="padding__bottom--large">
                <InlineMessage
                    intent={InlineMessage.Intent.INFO}
                    label={
                        formik.values.supplierNpi
                            ? 'If this address is incorrect contact support through messages.'
                            : "Select a supplier NPI to view it's billing address."
                    }
                />
            </div>
            <AddressDetailLabelValue
                label="Address"
                address1={childSupplierDetails?.address1}
                address2={childSupplierDetails?.address2}
                city={childSupplierDetails?.city}
                state={childSupplierDetails?.state}
                zip={childSupplierDetails?.zip}
            />
        </div>
    );
};
